.spellCard {
  --gap: 12px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr auto;
  gap: var(--gap);
  padding: 8px 16px;
  font-size: 14px;

  @media (min-width: 480px) {
    max-width: 400px;
  }

  > * {
    border-radius: 2px;
  }

  .details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .detail {
    background: var(--color-bg-white);
    padding: 8px 16px;
    border-radius: 2px;
  }

  .detail > div {
    font-weight: bold;
    font-size: 14px;
  }

  .title {
    font-weight: bold;
  }

  .description,
  .levelAndSchool,
  .source {
    margin: 0;
  }

  .levelAndSchool {
    font-style: italic;
  }

  .description {
    margin: 8px 0;
    line-height: 1.4;
    display: flex;
    flex-direction: column;
    gap: 8px;

    > div:last-child {
      flex-grow: 1;
    }
  }

  .source {
    font-size: 12px;

    > div {
      margin-bottom: 4px;
    }
  }

  @media print {
    -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important; /* Firefox 48 – 96 */
    print-color-adjust: exact !important; /* Firefox 97+, Safari 15.4+ */
    padding: 8px;
    gap: 8px;
    background: #fafafa;
    border-radius: 8px;
    border: 0.5px solid #666;
    color: #000;
    font-size: 10px;
    margin-bottom: -1px;
    margin-right: -1px;
    grid-template-rows: auto auto auto 1fr auto;
    break-inside: avoid;

    h3 {
      text-align: center;
      font-size: 12px;
      margin: 0;
    }

    > *:not(.details) {
      background: #fff;
      border-radius: 4px;
      padding: 4px 8px;
    }

    .details {
      gap: 8px;
      margin: 0;
    }

    .detail > div {
      font-size: 8px;
    }

    .detail {
      background: #fff;
      border-radius: 4px;
      padding: 8px;
    }

    .description {
      margin: 0;
      padding: 12px 8px 8px;
    }

    .source {
      font-size: 8px;

      div {
        display: none;
      }
    }
  }
}
